import { cardImageSources, type GenericCharacter } from './types'

export const genericAstro: GenericCharacter = {
  id: 'generic-astro',
  enabled: true,
  order: 7,
  displayName: 'Cosmo',
  icon: '🚀',
  imageSources: cardImageSources('generic-astro'),
}
